import React from 'react';
import { Box, Button, Stack, TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';

export default function GanttToolbar({
  search,
  onSearchChange,
  onCollapseAll,
  onExpandAll,
  onViewLevel,
  onRefresh,
  onAdd,
  api,
  onExportImage,
  modularUnits,
  selectedUnit,
  onUnitChange,
  showActual,
  onToggleShowActual,
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexWrap: 'wrap' }}>
      <TextField
        size="small"
        placeholder="CARI TUGAS..."
        value={search}
        onChange={(e) => onSearchChange?.(e.target.value)}
        sx={{ minWidth: 240 }}
      />
      <Stack direction="row" spacing={1} sx={{ ml: 1 }}>
        <Button size="small" variant="outlined" onClick={() => onCollapseAll?.()}>TUTUP SEMUA</Button>
        <Button size="small" variant="outlined" onClick={() => onViewLevel?.('project')}>BANGUNAN</Button>
        <Button size="small" variant="outlined" onClick={() => onViewLevel?.('category')}>KATEGORI</Button>
        <Button size="small" variant="contained" onClick={() => onExpandAll?.()}>BUKA SEMUA</Button>
      </Stack>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="unit-filter-label">Filter Bangunan</InputLabel>
        <Select
          labelId="unit-filter-label"
          label="Filter Bangunan"
          value={selectedUnit}
          onChange={(e) => onUnitChange(e.target.value)}
          renderValue={(selected) => { // This logic remains robust
            if (selected === 'ALL') {
              return 'Semua Bangunan';
            }
            const selectedItem = (modularUnits || []).find(unit => String(unit.id) === selected);
            return selectedItem ? selectedItem.name : '';
          }}
        >
          <MenuItem value="ALL">
            Semua Bangunan
          </MenuItem>
          {(modularUnits || []).map((unit) => (
            <MenuItem key={unit.id} value={String(unit.id)}>
              {unit.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControlLabel
        sx={{ ml: 1 }}
        control={
          <Checkbox
            size="small"
            checked={!!showActual}
            onChange={(e) => onToggleShowActual?.(e.target.checked)}
          />
        }
        label="Tampilkan Progress Actual"
      />
      <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
        <Button size="small" variant="outlined" startIcon={<RefreshIcon />} onClick={onRefresh}>SEGARKAN</Button>
        <Button
          size="small"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            // Use the new dialog-based add task function
            if (api && typeof api.addTask === 'function') {
              api.addTask();
            } else {
              onAdd?.();
            }
          }}
        >
          TAMBAH PEKERJAAN
        </Button>
        <Button size="small" variant="outlined" startIcon={<DownloadIcon />} onClick={onExportImage}>DOWNLOAD</Button>
      </Stack>
    </Box>
  );
}
